// extracted by mini-css-extract-plugin
export var chip = "_fu-0";
export var filterDropdown = "_fu-5";
export var filterItem = "_fu-6";
export var icon = "_fu-1";
export var removeButton = "_fu-3";
export var removeIcon = "_fu-4";
export var separator = "_fu-2";